import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./protected";
import React from "react";
import { SidebarProvider } from "../context/sidebar";

const Layout = React.lazy(() => import("../layouts"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Forms = React.lazy(() => import("../pages/forms"));
const Login = React.lazy(() => import("../pages/login"));
const Ecommerce = React.lazy(() => import("../pages/ecommerce"));

const Vendor = React.lazy(() => import("../pages/master/vendor"));

const MainRouter = createBrowserRouter([
  {
    path: "/",
    // element: (
    //   <ProtectedRoute
    //     element={
    //       <SidebarProvider>
    //         <Layout />
    //       </SidebarProvider>
    //     }
    //   />
    // ),
    element: (
      <SidebarProvider>
        <Layout />
      </SidebarProvider>
    ),
    children: [
      { index: true, element: <Dashboard />, handle: { name: "Beranda" } },
      { path: "forms", element: <Forms />, handle: { name: "Formulir" } },
      { path: "vendor", element: <Vendor />, handle: { name: "Vendor" } },
      // {
      //   path: "master",
      //   element: <></>,
      //   handle: { name: "Master" },
      //   children: [
      //     {
      //       path: "goods",
      //       element: <>barang</>,
      //       handle: { name: "Barang" },
      //       children: [
      //         {
      //           path: "forms",
      //           element: <>barang</>,
      //           handle: { name: "form" },
      //         },
      //         { path: "add", element: <>barang</>, handle: { name: "add" } },
      //       ],
      //     },
      //   ],
      // },
    ],
  },
  { path: "/login", element: <Login />, handle: { name: "Login" } },
  { path: "/store", element: <Ecommerce />, handle: { name: "Ecommerce" } },
]);

export default MainRouter;
